import React, { memo } from "react";
import { getOptimizedUrl } from "../../../../constants/globalFunction";
import "./Banner.css";

const Banner = ({ item }) => {
  const handleBannerClick = () => {
    if (item?.url) {
      window.open(item.url, "_blank");
    }
  };

  if (!item) return null;

  return (
    <div
      className="bannerCard"
      key={item?._id}
      onClick={handleBannerClick}
      style={{ cursor: item?.url ? "pointer" : "default" }}
    >
      <img
        className="bannerCard__img"
        src={getOptimizedUrl(item.image, 1200, 2200, 0.6)}
        alt={item?._id || "banner"}
        loading="lazy"
      />
    </div>
  );
};

export default memo(Banner);
